import { Percentage } from '@sparkdotfi/common-universal'

import { StusdsWarningData } from '../../types'
import { formatPercentage } from '@/domain/common/format'
import { Token } from '@/domain/types/Token'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Alert } from '@/ui/molecules/alert/Alert'

export interface StusdsWarningProps {
  stusdsWarningData: StusdsWarningData | undefined
  usds: Token
}

export function StusdsWarning({ stusdsWarningData, usds }: StusdsWarningProps) {
  return (
    <div className="flex flex-col gap-2">
      <Alert variant="warning">
        stUSDS offers a higher APY than Savings Vaults but comes with a higher risk profile. This product is offered by
        Sky, not Spark. Read more about the risks associated with stUSDS{' '}
        <ExternalLink to={links.docs.savings.stusds} variant="underline" className="whitespace-nowrap">
          here
        </ExternalLink>
        .
      </Alert>
      {stusdsWarningData && <LiquidityWarning stusdsWarningData={stusdsWarningData} usds={usds} />}
    </div>
  )
}

function LiquidityWarning({ stusdsWarningData, usds }: { stusdsWarningData: StusdsWarningData; usds: Token }) {
  if (stusdsWarningData.totalAssets.gt(stusdsWarningData.debt)) {
    return null
  }

  const fillPercentage = Percentage(stusdsWarningData.totalAssets.div(stusdsWarningData.debt), { allowMoreThan1: true })

  return (
    <Alert variant="error">
      Until deposits exceed {usds.format(stusdsWarningData.debt, { style: 'compact' })} USDS, withdrawals may be
      temporarily unavailable.{' '}
      <span className="whitespace-nowrap">
        Current deposits: {usds.format(stusdsWarningData.totalAssets, { style: 'compact' })}/
        {usds.format(stusdsWarningData.debt, { style: 'compact' })} (
        {formatPercentage(fillPercentage, { minimumFractionDigits: 2 })} filled).
      </span>
    </Alert>
  )
}
